/**
 * Triggers the "new message" email for a direct message that was just written
 * to Firestore. Messages go straight from the browser to Firestore, so the
 * email only happens if the screen also calls the API's direct-chat-notify
 * endpoint - a screen that skips this call saves the message silently.
 *
 * Only fires for a message that actually saved (addDirectMessage resolves 1).
 * Never throws: the message is already delivered in-app, so a failed email
 * request must not turn a successful send into an error for the sender.
 *
 * @param {Function} sendEmail - services/messagesService sendDMEmail
 * @param {{ saved: number, receiverId: *, message: string }} params
 * @returns {Promise<boolean>} true when the email request was accepted
 */
export async function notifyDirectMessageRecipient(
  sendEmail,
  { saved, receiverId, message },
) {
  if (saved !== 1 || !receiverId) return false;
  try {
    const response = await sendEmail({ userId: receiverId, message });
    return response?.errorCode === 0;
  } catch (error) {
    console.error("Direct message email request failed", error);
    return false;
  }
}
